module.exports = __webpack_public_path__ + "img/essay-card.d5debe28.svg";